export var DexieTable;
(function (DexieTable) {
    DexieTable["Events"] = "events";
    DexieTable["Entities"] = "entities";
    DexieTable["DerivedTaskComponents"] = "derived_taskComponents";
    DexieTable["Metadata"] = "metadata";
})(DexieTable || (DexieTable = {}));
export var DexieEventKeys;
(function (DexieEventKeys) {
    DexieEventKeys["SequenceNumber"] = "sequenceNumber";
    DexieEventKeys["ID"] = "id";
    DexieEventKeys["EntityID"] = "entityID";
    DexieEventKeys["Data"] = "data";
})(DexieEventKeys || (DexieEventKeys = {}));
export var DexieEntityKeys;
(function (DexieEntityKeys) {
    DexieEntityKeys["RowID"] = "rowID";
    DexieEntityKeys["ID"] = "id";
    DexieEntityKeys["EntityType"] = "entityType";
    DexieEntityKeys["LastEventID"] = "lastEventID";
    DexieEntityKeys["LastEventTimestampMillis"] = "lastEventTimestampMillis";
    DexieEntityKeys["Data"] = "data";
})(DexieEntityKeys || (DexieEntityKeys = {}));
export var DexieDerivedTaskComponentKeys;
(function (DexieDerivedTaskComponentKeys) {
    DexieDerivedTaskComponentKeys["TaskID"] = "taskID";
    DexieDerivedTaskComponentKeys["ComponentID"] = "componentID";
    DexieDerivedTaskComponentKeys["DueTimestampMillis"] = "dueTimestampMillis";
})(DexieDerivedTaskComponentKeys || (DexieDerivedTaskComponentKeys = {}));
export var DexieMetadataKeys;
(function (DexieMetadataKeys) {
    DexieMetadataKeys["Key"] = "key";
    DexieMetadataKeys["Value"] = "value";
})(DexieMetadataKeys || (DexieMetadataKeys = {}));
//# sourceMappingURL=tables.js.map